import { describeSaveFailure } from "./describeSaveFailure";
import { showGlobalToast } from "./showGlobalToast";

/**
 * Await a request the user started and tell them when it fails (PREC-4390).
 *
 * An RTK `.unwrap()` that nobody catches becomes an unhandled rejection: nothing in the app listens
 * for one, and `rtkRejectQueryMiddleware` acts on rejected *queries* only, so a refused save left
 * the control looking as if it had worked. Bugsink SIGNALIST-4 counted 63 of them in the campaign
 * settings modal, the Connected accounts toggles and the list source step. The toast carries the
 * reason the API or the transport gave, after `failureMessage`.
 *
 * Answers whether `run` succeeded, and never rejects, so a caller can stop where it is.
 */
export async function runOrToast(
	run: () => Promise<unknown>,
	failureMessage: string
): Promise<boolean> {
	try {
		await run();

		return true;
	} catch (error) {
		showGlobalToast(describeSaveFailure(error, failureMessage));

		return false;
	}
}
